import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { client } from "../../bit/board/hooks/useGraphQLClient";
import { MUTATION_GET_CALLER_ACS_TOKEN_AND_TARGET_TEAMS_USER_IDS } from "../../config/graphql/mutation";

export const useTeamsCallerTokenAndTargetTeamsUserIds = ({
  emails,
  enabled = true,
}: {
  emails: string[];
  enabled?: boolean;
}) => {
  const { data, status, isLoading, error } = useQuery<{
    getCallerAcsTokenAndTargetTeamsUserIds: CallerAcsTokenAndTargetTeamsUserIdsResponse;
  }>(
    ["getCallerAcsTokenAndTargetTeamsUserIds", emails],
    () => {
      return client.request(
        MUTATION_GET_CALLER_ACS_TOKEN_AND_TARGET_TEAMS_USER_IDS,
        {
          input: {
            emails,
          },
        },
      );
    },
    {
      enabled:
        enabled &&
        emails.length > 0 &&
        emails.every((email) => !!email?.trim()),
      retry: false,
      refetchOnWindowFocus: false,
    },
  );

  const callerAcsToken = useMemo(
    () => data?.getCallerAcsTokenAndTargetTeamsUserIds?.callerAcsToken,
    [data],
  );

  const isGroupCall = useMemo(
    () =>
      data?.getCallerAcsTokenAndTargetTeamsUserIds?.targetTeamsUsers?.[0]
        ?.isGroup,
    [data],
  );

  const targetTeamsUserIds = useMemo(
    () =>
      data?.getCallerAcsTokenAndTargetTeamsUserIds?.targetTeamsUsers?.[0]?.teamsUsers
        ?.map((user) => user.teamsUserId)
        .filter(Boolean)
        .join(","),
    [data],
  );

  return {
    callerAcsToken,
    targetTeamsUserIds,
    isGroupCall,
    data,
    status,
    isLoading,
    error,
  };
};
